import { GlobalHotKeys, KeyMap } from 'react-hotkeys'
import { useActions } from '../hooks/useActions'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { track } from '@tldraw/tldraw'

export const KeyboardShortcuts = track(() => {
  const editor = useEditor()
  const actions = useActions()

  if (!editor.getInstanceState().isFocused) return null

  const handler = (cb: () => any) => {
    return (e?: KeyboardEvent) => {
      e?.preventDefault()
      cb()
    }
  }

  const keyMap: KeyMap = {}
  const handlers: { [key: string]: (e: KeyboardEvent | undefined) => void } = {}

  Object.values(actions).forEach((action) => {
    if (!action.kbd) return

    keyMap[action.id] = action.kbd
    handlers[action.id] = handler(() => action.onSelect())
  })

  return <GlobalHotKeys keyMap={keyMap} handlers={handlers} allowChanges />
})
